import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, h = ({ size: e = 16, useVw: t, useRem: o, color: n, withColor: c, removeClassName: l, disableSSR: m, style: i, ...p }) => {
  const x = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(f, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-licaibao", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), height: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: l ? "" : "32px-çè´¢å®"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: l ? "" : "normal",
        clipRule: "evenodd",
        fillRule: "evenodd",
        fill: c ? r(n, 0, "#262933") : "#262933",
        datafollowfill: c ? r(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M14.645 12.543a1.916 1.916 0 0 1 2.71 0l2.79 2.79a1.916 1.916 0 0 1 0 2.71l-2.79 2.79a1.916 1.916 0 0 1-2.71 0l-2.79-2.79a1.916 1.916 0 0 1 0-2.71l2.79-2.79Zm1.437 1.273 2.79 2.79a.116.116 0 0 1 0 .164l-2.79 2.79a.116.116 0 0 1-.164 0l-2.79-2.79a.116.116 0 0 1 0-.164l2.79-2.79a.116.116 0 0 1 .164 0Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M5.498 5.5a.9.9 0 0 1 .9-.9h18.154a.9.9 0 1 1 0 1.8h-1.627l4.202 5.748a8.9 8.9 0 0 1 .492 9.755l-1.804 3.076a4.9 4.9 0 0 1-4.227 2.421H10.483a4.9 4.9 0 0 1-4.21-2.391l-1.837-3.085a8.9 8.9 0 0 1 .46-9.808L9.076 6.4H6.397a.9.9 0 0 1-.9-.9Zm5.807.9-4.956 6.778a7.1 7.1 0 0 0-.367 7.825l1.838 3.084a3.1 3.1 0 0 0 2.663 1.513h11.105a3.1 3.1 0 0 0 2.674-1.531l1.805-3.076a7.1 7.1 0 0 0-.393-7.783L20.695 6.4h-9.39Z"
        }
      )
    )
  )));
}, L = h;
export {
  L as default
};
